// src/hooks/useFxMap.js
import { useEffect, useState } from 'react';
import { getFxMapEUR } from '../services/fx';

const REGION_TO_CURRENCY = {
  RS:'RSD', BA:'BAM', ME:'EUR', MK:'MKD', AL:'ALL',
  HR:'EUR', SI:'EUR', HU:'HUF', RO:'RON', BG:'BGN',
  PL:'PLN', CZ:'CZK', SK:'EUR', AT:'EUR', DE:'EUR',
  IT:'EUR', FR:'EUR', ES:'EUR', PT:'EUR', GR:'EUR',
  NL:'EUR', BE:'EUR', LU:'EUR', IE:'EUR', LT:'EUR',
  LV:'EUR', EE:'EUR', DK:'DKK', SE:'SEK', NO:'NOK',
  FI:'EUR', IS:'ISK', CH:'CHF', GB:'GBP',
  US:'USD', CA:'CAD', MX:'MXN', BR:'BRL', AR:'ARS',
  CL:'CLP', CO:'COP', PE:'PEN',
  CN:'CNY', JP:'JPY', KR:'KRW', IN:'INR', HK:'HKD',
  TW:'TWD', SG:'SGD', TH:'THB', MY:'MYR', ID:'IDR',
  TR:'TRY', AE:'AED', SA:'SAR', IL:'ILS',
  ZA:'ZAR', NG:'NGN', EG:'EGP', KE:'KES',
  AU:'AUD', NZ:'NZD', UA:'UAH', RU:'RUB', BY:'BYN'
};

const LANG_TO_CURRENCY = {
  sr:'RSD', bs:'BAM', hr:'EUR', sl:'EUR', mk:'MKD',
  hu:'HUF', ro:'RON', bg:'BGN', pl:'PLN', cs:'CZK', sk:'EUR',
  de:'EUR', it:'EUR', fr:'EUR', es:'EUR', pt:'EUR',
  en:'USD', zh:'CNY', ja:'JPY', ko:'KRW', ru:'RUB', uk:'UAH', tr:'TRY',
  el:'EUR', da:'DKK', sv:'SEK', no:'NOK', fi:'EUR', is:'ISK', nl:'EUR'
};

const extractRegion = (langTag) => {
  if (!langTag) return null;
  try {
    if (typeof Intl !== 'undefined' && typeof Intl.Locale === 'function') {
      const loc = new Intl.Locale(langTag);
      if (loc && loc.region) return String(loc.region).toUpperCase();
    }
  } catch {}
  const parts = String(langTag).replace('_','-').split('-');
  if (parts.length >= 2) {
    const maybeRegion = parts[1];
    if (maybeRegion && maybeRegion.length === 2) return maybeRegion.toUpperCase();
  }
  return null;
};

export function detectCurrency(i18nLang) {
  const loc =
    i18nLang ||
    (typeof navigator !== 'undefined' && (navigator.language || navigator.languages?.[0])) ||
    'en-US';

  const region = extractRegion(loc);
  if (region && REGION_TO_CURRENCY[region]) return REGION_TO_CURRENCY[region];

  const lang = String(loc).toLowerCase().split(/[-_]/)[0];
  return LANG_TO_CURRENCY[lang] || 'EUR';
}


export const pickDefaultCurrency = (langTag) => {
  const region = extractRegion(langTag);
  if (region && REGION_TO_CURRENCY[region]) return REGION_TO_CURRENCY[region];
  const lang = String(langTag || '').toLowerCase().split(/[-_]/)[0] || 'en';
  if (LANG_TO_CURRENCY[lang]) return LANG_TO_CURRENCY[lang];
  return 'EUR';
};

// promeni potpis i referencu unutra
export function useFxMap({ ttlMinutes = 360, initialLocale } = {}) {
  const [fx, setFx] = useState({ base: 'EUR', rates: { RSD: 117.2 } });
  const [loading, setLoading] = useState(true);
  const [provider, setProvider] = useState('init');

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      try {
        const res = await getFxMapEUR(ttlMinutes);
        if (!mounted) return;
        setFx({ base: 'EUR', rates: res.rates });
        setProvider(res.provider);
      } finally { setLoading(false); }
    })();
    return () => { mounted = false; };
  }, [ttlMinutes]);

  const toEUR = (amount, from) => !Number.isFinite(amount) ? 0 : (!from || from==='EUR') ? amount : (fx.rates[from] ? amount / fx.rates[from] : amount);
  const fromEUR = (amountEUR, to)   => !Number.isFinite(amountEUR) ? 0 : (!to   || to  ==='EUR') ? amountEUR : (fx.rates[to]   ? amountEUR * fx.rates[to]   : amountEUR);

  const defaultCurrency = pickDefaultCurrency(
    initialLocale || (typeof navigator !== 'undefined' ? navigator.language : 'en')
  );

  return { fx, loading, provider, toEUR, fromEUR, defaultCurrency };
}

